const Conf = {
  api: {
    // base_url: `${process.env.REACT_APP_API_BASE_URL}`
    // base_url: "http://staging.e-connectsolutions.com/puda-dev/PUDA-Gateway/api/"
    // base_url: "http://112.196.37.3:801/puda-Gateway/api/"
    // base_url: "http://eservices.gmadaipms.in:801/puda-Gateway/api/"
    //base_url: "http://152.67.1.185:83/puda-gateway/api/"
    base_url: "https://puda.gov.in/puda-Gateway/api/"
     //base_url:"http://localhost:63990/api/"


  }
}
export default Conf;